import { render, staticRenderFns } from "./productShelves.vue?vue&type=template&id=f0d52f4a&scoped=true&"
import script from "./productShelves.vue?vue&type=script&lang=js&"
export * from "./productShelves.vue?vue&type=script&lang=js&"
import style0 from "./productShelves.vue?vue&type=style&index=0&id=f0d52f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d52f4a",
  null
  
)

export default component.exports